import { render, staticRenderFns } from "./barcodeStorageHistory.vue?vue&type=template&id=2f33e970&scoped=true&"
import script from "./barcodeStorageHistory.vue?vue&type=script&lang=js&"
export * from "./barcodeStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./barcodeStorageHistory.vue?vue&type=style&index=0&id=2f33e970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33e970",
  null
  
)

export default component.exports